import { render, staticRenderFns } from "./downloadModal.vue?vue&type=template&id=28f7e614&scoped=true"
import script from "./downloadModal.vue?vue&type=script&lang=js"
export * from "./downloadModal.vue?vue&type=script&lang=js"
import style0 from "./downloadModal.vue?vue&type=style&index=0&id=28f7e614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f7e614",
  null
  
)

export default component.exports